import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function setClearDetails(draft: Draft<IInterventionData>) {
  draft.getDetails.values = null;
}

export default setClearDetails;
